import { render, staticRenderFns } from "./comp_CategoriesMegaMenu-Image.vue?vue&type=template&id=772e6ec4&scoped=true&"
import script from "./comp_CategoriesMegaMenu-Image.vue?vue&type=script&lang=js&"
export * from "./comp_CategoriesMegaMenu-Image.vue?vue&type=script&lang=js&"
import style0 from "./comp_CategoriesMegaMenu-Image.vue?vue&type=style&index=0&id=772e6ec4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772e6ec4",
  null
  
)

export default component.exports